<template>

  <div class="pogs-list--panels">

    <template v-if="!cases.length">
      <div class="pogs-list__item" @click="createNewCase">
        <header>
          <h3></h3>
        </header>
        <div class="content--info" @click="toggleOverlay">
          <label>Click here or click the Add button to add New Case.</label>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="pogs-list__item"
           v-for="(c, index) in cases" :key="c._id"
           @click="editCaseForm(c._id)">

          <!-- CASE HEADER -->
          <header>
            <h2>Case #{{ c.caseNum }}</h2>
            <div class="pogs-tag--tiny"
                 :class="{'red-tag' : !c.isClose}">
                 {{!c.isClose ? 'Open' : (c.submissionId ? 'Submitted' : 'Closed') }}
            </div>
            <div class="smd-spacer"/>
            <template  v-if="!c.dischargeDate">
              <div class="pogs-tag--pill yellow-tag">Admitted</div>
              <p v-if="c.room"><strong>Rm {{ c.room }} </strong></p>
            </template>
            <!--<smd-options :items="actions(c, index)"-->
                         <!--@item-selected="doAction"/>-->
            <smd-btn pilled-o
                     @click.stop="closePatientCase(index)"
                     v-if="!c.isClose">Close</smd-btn>
            <smd-btn pilled-o
                     @click.stop="confirmReopenCase(c.patientid, c._id)"
                     v-if="c.isClose">Reopen</smd-btn>
          </header>

          <div class="content case">

            <template v-if="!c.isClose">

              <!-- ADMISSION -->
              <div class="data-entry__row" v-if="c.admissionDate" >
                <label>Admission Date</label>
                <p>{{ c.admissionDate | formatDate }}</p>
              </div>
              <!-- Age -->
              <div class="data-entry__row" v-if="typeof c.age === 'number'" >
                <label>Age on Admission</label>
                <p>{{ c.age }}</p>
              </div>

              <!-- Patient's Weight -->
              <div class="data-entry__row">
                <label>Patient's Vitals</label>
                <p>{{ c.weight ? c.weight : "--" }} kg / {{ c.height ? c.height : "--" }} cm / {{ c.bmi ? c.bmi : "--" }} kg/m<sup>2</sup></p>
              </div>

              <!-- Patient's Height -->
              <div class="data-entry__row" v-if="typeof c.height === 'number'" >
                <label>Patient's Height</label>
                <p>{{ c.height }}</p>
              </div>

              <!-- Patient's BMI -->
              <div class="data-entry__row" v-if="typeof c.bmi === 'number'" >
                <label>Patient's BMI</label>
                <p>{{ c.bmi }}</p>
              </div>

              <!-- OB SCORE-->
              <div class="pogs-panel--o">
                <header>
                  <h3>Obstetric History</h3>
                  <div class="smd-spacer"/>
                </header>
                <div class="content">
                  <label>OB Score</label>
                  <div class="pogs-list--table">
                    <div class="pogs-list__item--col"
                         v-for="(ob,index) in $options.ObScore" :key="index">
                      <div class="pogs-list__item">
                        <label normal>{{ob.label}}</label>
                        <h3>{{formatObScore(c[ob.itemKey])}}</h3>
                      </div>
                    </div>
                  </div>

                  <template v-if="c.obstetricHistory">
                    <div class="data-entry">
                      <label>Category</label>
                      <label>Condition</label>
                    </div>

                    <div class="data-entry" v-for="(value, key) in c.obstetricHistory" :key="key">
                      <p><strong>{{ value.categoryId | decodeObstetricHistoryCategory }}</strong></p>
                      <p>{{ key | decodeObstetricHistoryCondition }}</p>
                    </div>
                  </template>
                </div>

              </div>

              <!-- Past Medical History -->
              <div class="pogs-panel--o" v-if="c.medicalHistory">
                <header>
                  <h3>Past Medical Conditions</h3>
                  <div class="smd-spacer"/>
                </header>

                <div class="content">
                  <div class="data-entry">
                    <label>Category</label>
                    <label>Condition</label>
                  </div>

                  <div class="data-entry" v-for="(value, key) in c.medicalHistory" :key="key">
                    <p><strong>{{ value.categoryId | decodeMedicalHistoryCategory }}</strong></p>
                    <p>{{ key | decodeMedicalHistoryCondition }}</p>
                  </div>

                </div>
              </div>

              <!-- GYNECOLOGICAL CONDITION -->
              <div class="pogs-panel--o" v-if="c.isGyne">
                <header>
                  <h3>Gyne</h3>
                  <div class="smd-spacer"/>
                </header>

                <div class="content">
                  <div class="data-entry-3">
                    <label>Category</label>
                    <label>Condition</label>
                    <label>Stage</label>
                  </div>

                  <div class="data-entry-3" v-for="(value, key) in c.gynecologicalDiagnosis" :key="key">
                    <p><strong>{{ value.categoryId | decodeGyneCategory }}</strong></p>
                    <p>{{ key | decodeGyneCondition }}</p>
                    <p>{{ value.gyneStage | decodeGyneStageTypes(value.categoryId) }}</p>
                  </div>

                </div>
              </div>
              <div class="pogs-panel--o" v-if="c.isGyne">
                <header>
                  <h3>Gyne Co-morbidities</h3>
                  <div class="smd-spacer"/>
                </header>

                <div class="content">
                  <div class="data-entry">
                    <label>Category</label>
                    <label>Condition</label>
                  </div>

                  <div class="data-entry" v-for="(value, key) in c.gynemorbidities" :key="key">
                    <p><strong>{{ value.categoryId | decodeMorbidities }}</strong></p>
                    <p>{{ key | decodeMorbidityCondition }}</p>
                  </div>

                </div>
              </div>

              <div class="pogs-panel--o" v-if="isConcomitantProcedure(c.concomitantProcedure)">
                <header>
                  <h3>Procedures</h3>
                  <div class="smd-spacer"/>
                </header>


                <!-- CONCOMITANT PROCEDURE -->

                <div class="content">
                  <div class="data-entry-3">
                    <label>Category</label>
                    <label>Procedure</label>
                    <label>Type</label>
                  </div>

                  <div class="data-entry-3" v-for="(value, key) in c.concomitantProcedure" :key="key">
                    <p><strong>{{ value.categoryId | decodeProcedureCategory }}</strong></p>
                    <p>{{ key | decodeProcedureConditions }}</p>
                    <p>{{ value.procedureType | decodeProcedureTypes(value.categoryId) }}</p>
                  </div>

                </div>
              </div>
            </template>

            <div class="pogs-panel--nob" v-for="section in c.sections">
              <header v-if="section.title">
                <h3>{{section.title}}</h3>
              </header>

              <div class="content">

                <div class="data-entry"
                     v-for="(item, idx) in section.data" :key="idx">

                  <label>{{item.label}}</label>

                  <div v-if="item.label === 'Neonatal'">
                    <span v-for="(baby, index) in item.value">
                      <p><strong>Baby {{index+1}}</strong></p>
                      <p>Pediatric Aging: {{baby.pediatricAge}}</p>
                      <p>Pediatric Vitals: {{baby.pediatricWeight ? baby.pediatricWeight : "--"}} g / {{baby.pediatricHeight ? baby.pediatricHeight : "--"}} cm</p>
                      <p>Anomalies: {{baby.anomalies ? baby.anomalyOthers : 'None'}}</p>
                    </span>
                  </div>

                  <p v-else-if="item.value">
                    {{item.value}}
                  </p>

                  <p v-else>
                    <span v-if="item.type === 1">
                      <span v-if="typeof item.weeks === 'number'">{{item.weeks}} {{parseInt(item.weeks) > 1 ? 'weeks ' : 'week '}}</span>
                      <span v-if="typeof item.days === 'number'">and {{item.days}} {{parseInt(item.days) > 1 ? 'days' : 'day'}}</span>
                    </span>
                    <span v-else>
                      <span v-if="typeof item.range === 'number'"> {{ item.range | decodeAOGRange }} </span>
                    </span>
                  </p>

                </div>

              </div>
            </div>
          </div>
      </div>
    </template>

  </div>

</template>

<script>
  import { mapGetters } from 'vuex'
  import { GETTER_MEDICAL_HISTORY } from '../../../store/forms/case-form-state'
  import {
    ACTION_CLOSE_PATIENT_CASE,
    ACTION_LOAD_PATIENT_CASES,
    ACTION_REOPEN_PATIENT_CASE } from '../../../store/modules/patients'

  import Routes from '../../../router/route-constants'
  import uiHelper from '../../../mixins/uihelper'
  import CaseValidation from '../../../mixins/case-validation-mixin'

  import ClosedCase  from '../../../reference/case/sections/closed-case'
  import ObScore from '../../../reference/case/sections/obstetric-score'
  import PregnancySection from '../../../reference/case/sections/pregnancy-section'
  import DeliverySection from '../../../reference/case/sections/delivery-section'
  import GyneSection from '../../../reference/case/sections/gyne-section'
  import DischargSection from '../../../reference/case/sections/discharge-section'


  const PREVIEW_SECTIONS = [
    {key: 'isPregnancy' , title: 'Pregnancy', reference: PregnancySection},
    {key: 'deliveryDate', title: 'Delivery' , reference: DeliverySection},
    {key: ['motherCondition', 'dischargeDate'], title: 'Discharge', reference: DischargSection}
  ];

  export default {
    props: {
      patient: null
    },
    mixins: [uiHelper, CaseValidation],
    computed: {
      ...mapGetters({
        medicalHistory: GETTER_MEDICAL_HISTORY
      }),
      cases() {
        const p = this.patient;
        const caseList = Object.keys(p.cases).map(key => (p.cases[key]));
        if (p && caseList) {
          for (var idx in caseList) {
            let sections = [];
            if (caseList[idx].isClose) {
              sections.push({data: this.fetchSectionData(ClosedCase, caseList[idx])});
            }
            else {
              for (var x in PREVIEW_SECTIONS) {
                const item = PREVIEW_SECTIONS[x];
                let insert = caseList[idx][item.key];
                if (item.key instanceof Array) {
                  for (var y in item.key) {
                    insert = caseList[idx][item.key[y]] || insert;
                  }
                }
                if (insert) {
                  sections.push({
                    title: item.title || null,
                    data: item.reference ? this.fetchSectionData(item.reference, caseList[idx]) : null
                  });
                }
              }
            }
            caseList[idx]['sections'] = sections;

          }
          return caseList;
        }
        return [];
      }
    },
    methods: {
      formatObScore(obScore){
        return typeof obScore === 'number' ? obScore : '-'
      },
      isConcomitantProcedure(item){
          return item instanceof Object ? !!Object.keys(item).length : false
      },
      actions(patient, caseIndex) {
        if (patient.isClose) {
          return [{id: 'view', icon: 'action-edit', label: 'View', caseId: patient._id}];
        }
        return [
          {id: 'edit', icon: 'action-edit', label: 'Edit', caseId: patient._id, caseIndex},
          {id: 'close', icon: 'action-close', label: 'Close', caseId: patient._id, caseIndex}
        ];
      },
      createNewCase() {
        this.toggleOverlay();
        this.$router.push({
          name: Routes.ROUTE_NEW_PATIENT_CASE
        })
      },
      decodeItemValue(value, decoder) {
        return decoder ? this.$options.filters[decoder](value) : value
      },
      closePatientCase(caseIndex){
        const params = {
          patientid: this.$route.params.patientid,
          caseid: this.cases[caseIndex]._id
        };
        const validationResult = this.validateCase(this.$options.caseValidationRules, this.cases[caseIndex]);
        if (validationResult.length > 0) {
          this.showCloseCaseDialog(validationResult);
        } else {
          this.confirmCloseCase(params)
        }
      },
      confirmReopenCase(patientid, caseid){
        const store   = this.$store;
        const toasted = this.$toasted;
        const reloadPatientCase = this.reloadPatientCase;
        this.$dialog.confirm('Are you sure you want to reopen patient case ?', {cancelText: 'Cancel'})
          .then(function () {
            store.dispatch(ACTION_REOPEN_PATIENT_CASE, {patientid, caseid})
              .then((result) => {
                if(result.error){
                  toasted.show(result.error);
                }else if(result.message){
                  reloadPatientCase(patientid);
                  toasted.show(result.message);
                }
                else{
                  toasted.show('Something went wrong while reoping the case.');
                }
              });
          }).catch()
      },
      confirmCloseCase(params){
        const store  = this.$store;
        const toasted     = this.$toasted;
        const reloadPatientCase = this.reloadPatientCase;
        this.$dialog.confirm('Are you sure you want to close the case ?', {cancelText: 'Cancel'})
          .then(function () {
            store.dispatch(ACTION_CLOSE_PATIENT_CASE, params)
              .then(() => {
                reloadPatientCase(params.patientid);
                toasted.show('Patient case has been successfully closed!');
              });
          }).catch()
      },
      doAction(item) {
        const params = {
          patientid: this.$route.params.patientid,
          caseid: item.caseId
        };

        if (item.id !== 'close'){
          this.toggleOverlay();
          this.$router.push({
            name: Routes.ROUTE_EDIT_PATIENT_CASE,
            params: params
          })
        }
        else {
          this.closePatientCase(item.caseIndex)
        }
      },
      editCaseForm(caseid){
        const params = {
          patientid: this.$route.params.patientid,
          caseid: caseid
        };

        this.toggleOverlay();
        this.$router.push({
          name: Routes.ROUTE_EDIT_PATIENT_CASE,
          params: params
        })
      },
      fetchSectionData(sectionItems, caseItem) {
        let data = [];
        for (let idx in sectionItems) {
          const item = sectionItems[idx];

          // check if its not visible
          if (item.isVisible && !item.isVisible(caseItem)) {
            continue;
          }

          let key = item.itemKey;
          let temp = {};
          if (key instanceof Array) {
            temp.label = sectionItems[idx].label;
            for (let x in key) {
              if (caseItem[key[x]] || typeof caseItem[key[x]] === 'number') {
                temp[item.legend[x]] = this.decodeItemValue(caseItem[key[x]], item.decoder ? item.decoder[x] : item.decoder);
              }
            }
          }
          else if (caseItem[key]) {
            if (this.isOtherItem(key, caseItem[key])) {
              key = sectionItems[idx].otherItemKey;
            }
            if(caseItem[key] instanceof Object && key !== 'neonatal'){
              const caseItemObjectKey = Object.keys(caseItem[key]);
              const tempValue = [];
              caseItemObjectKey.forEach(insideKey => {
                if (typeof item.decoder === 'object') {
                  let _decoders = Object.keys(item.decoder);
                  _decoders.forEach( (decoder) => {
                    if (item.decoder[decoder](caseItem)) tempValue.push(this.decodeItemValue(insideKey, decoder));
                  })
                } else {
                  tempValue.push(this.decodeItemValue(insideKey, item.decoder));
                }
              });
              temp.value = tempValue.join(', ');
            }else{
              temp.value = this.decodeItemValue(caseItem[key], item.decoder);
            }
            temp.label = sectionItems[idx].label;
          }
          if (Object.keys(temp).length !== 0) {
            data.push(temp);
          }
        }
        return data;
      },
      isOtherItem(key, val) {
        return this.isGtdComplicationOthers(key, val) ||
          this.isSurgicalInterventionOthers(key, val) ||
          this.isImmediateCauseOthers(key, val)
      },
      isGtdComplicationOthers: (key, val) => key === 'gtdComplication' && val === 8,
      isSurgicalInterventionOthers: (key, val) => key === 'surgicalIntervention' && val === 6,
      isImmediateCauseOthers: (key, val) => key === 'immediateCause' && val === 8,
      reloadPatientCase(patientid) {
        this.$store.dispatch(ACTION_LOAD_PATIENT_CASES, patientid)
          .then((data) => {
            console.log("Patient cases has been successfully updated!")
          });
      }
    },
    ObScore
  }

</script>
